import { IosShare } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";

function isInStandaloneMode() {
    return (window.matchMedia('(display-mode: standalone)').matches);
}

export const AddToHomeMessage = () => {
	const [show, setShow] = useState(!isInStandaloneMode());

	return show ? (
	<div style={{position: 'fixed', bottom: '25px', zIndex: 2}} onClick={() => setShow(false)}>
		<Alert 
		severity="success" 
		icon={false}
		onClose={() => setShow(false)} 
		sx={{
			margin: 'auto',
			width: '95%',
			fontSize: '13px',
			textAlign: 'center'
		}}>
			<span>Install this application on your home screen for quick and easy access. </span> <br/>
			<span>Just tap <IosShare fontSize="small"/> and then <b>'Add to Home Screen'</b>.</span>
		</Alert>
	</div>): null;
}